<script setup>
setPageTitle(PageMeta.Businesses.preview.title)
definePage({ meta: PageMeta.Businesses.preview.meta })

import { useBusinessStore } from '@/@vxapp/Businesses/useBusinessStore'

import BusinessPreviewPage from '@/views/setup/businesses/preview/BusinessPreviewPage.vue'

const route = useRoute()
const businessesStore = useBusinessStore()

watch(
  () => businessesStore.messagesVariables,
  async newVal => {
    //setPageTitle(businessesStore.messagesVariables.)
  },
  { deep: true, immediate: false }
)

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalBusinessesMenu :business-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <BusinessPreviewPage
          v-if="route.params.guid"
          :business-g-u-i-d="route.params.guid"
        />
      </VCol>
    </VRow>
  </section>
</template>
